module.exports = __webpack_public_path__ + "media/homeHeroLargeBackground.70e5b781.svg";